import React, { useEffect, useState } from "react";
import DriverTagsMappingList from "../../components/DriverTagsMappings/DriverTagsMappingsList";
import ListPagination from "../../components/Common/ListPagination";
import DriverTagsMappingsFormModal from "../../components/DriverTagsMappings/DriverTagsMappingFormModal";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as DriverTagsActions from "../../store/actions/DriverTags";
import Permission from "../../components/Common/Permission";
import MenuActionsMappings from "../../constants/Menu/MenuActionsMappings";
import MenuNames from "../../constants/Menu/MenuNames.json";
import { FlexContainer, Heading } from "../../constants/assets/containers";
import FilterButton from "../../components/Common/FilterButton";

const DriverTagsMapping = (props) => {
  const {
    driverTagsMappingList,
    getDriverTagsMappingList,
    nextPageMappings,
    prevPageMappings,
    activeFiltersMappings,
  } = props;
  const [currentPage, setCurrentPage] = useState(1);
  const [modalState, setModalState] = useState("");
  const allActions = MenuActionsMappings[MenuNames.DRIVER_TAG];

  //handle pagination
  const handleNavClick = (action) => {
    if (action === "prev") {
      let pageRequest = {
        page: currentPage - 1,
      };
      setCurrentPage(currentPage - 1);
      getDriverTagsMappingList(
        activeFiltersMappings,
        pageRequest,
        "ACCOUNTING"
      );
    } else {
      let pageRequest = {
        page: currentPage + 1,
      };
      setCurrentPage(currentPage + 1);
      getDriverTagsMappingList(
        activeFiltersMappings,
        pageRequest,
        "ACCOUNTING"
      );
    }
  };

  const handleModalStateChange = (state) => {
    setModalState(state);
  };

  const handleClose = () => {
    setModalState("");
  };

  useEffect(() => {
    getDriverTagsMappingList({}, {}, "ACCOUNTING");
  }, []);

  useEffect(() => {
    setCurrentPage(1);
  }, [JSON.stringify(activeFiltersMappings)]);

  return (
    <div className="driver-tags-mapping-view container">
      <FlexContainer align="flex-start">
        <Heading>Driver Tags(Accounting) mapping</Heading>
        <div className=" actionBar mb-20 flex items-center justify-end">
          <Permission requiredPerms={[allActions.MAPPING_LIST]}>
            <FilterButton
              activeFilters={activeFiltersMappings}
              handleClick={() => handleModalStateChange("Filter")}
            />
          </Permission>
        </div>
      </FlexContainer>
      <DriverTagsMappingList driverTagsMappingsList={driverTagsMappingList} />
      <ListPagination
        nextPage={nextPageMappings}
        prevPage={prevPageMappings}
        handleNavClick={handleNavClick}
      />
      {modalState && (
        <DriverTagsMappingsFormModal
          mappingType="accounting"
          modalState={modalState}
          handleClose={handleClose}
        />
      )}
    </div>
  );
};

function mapStateToProps(state) {
  const { DriverTags } = state;
  return {
    driverTagsMappingList: DriverTags.driverTagsMappingList,
    driverTagsList: DriverTags.driverTagsList,
    nextPageMappings: DriverTags.nextPageMappings,
    prevPageMappings: DriverTags.prevPageMappings,
    activeFiltersMappings: DriverTags.activeFiltersDriverTagsMappings,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getDriverTagsMappingList: bindActionCreators(
      DriverTagsActions.getDriverTagsMappingList,
      dispatch
    ),
    getDriverTagsList: bindActionCreators(
      DriverTagsActions.getDriverTagsList,
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DriverTagsMapping);
